// Le mouvement de la boutique, chargé seulement quand le réglage « Animations » est coché.
// Il écoute animolife.js sans le modifier : retirer ce fichier rend la boutique telle qu'avant.
(() => {
  const $ = (sel, racine = document) => racine.querySelector(sel);
  const $$ = (sel, racine = document) => [...racine.querySelectorAll(sel)];
  const calme = matchMedia("(prefers-reduced-motion: reduce)");
  const racine = document.documentElement;
  const SORTIE = "cubic-bezier(0.16, 1, 0.3, 1)";
  const SOUPLE = getComputedStyle(racine).getPropertyValue("--m-souple").trim() || SORTIE;
  const REBOND = getComputedStyle(racine).getPropertyValue("--m-rebond").trim() || SORTIE;
  const visible = (el) => el && el.offsetParent !== null;

  /* --- Vers la fiche : la photo touchée porte le nom que la fiche donne à la sienne --- */
  let dernierLien = null;
  document.addEventListener("click", (e) => (dernierLien = e.target.closest("a[href]")), true);
  addEventListener("pageswap", (e) => {
    if (!e.viewTransition || !dernierLien) return;
    const vers = new URL(e.activation?.entry?.url || location.href);
    const lien = new URL(dernierLien.href, location.href);
    if (vers.pathname !== lien.pathname || !/\/products\//.test(vers.pathname)) return;
    const photo =
      $(".case-art .est-vue img", dernierLien.closest("[data-case]") || document.createElement("div")) ||
      $(".case-art img", dernierLien.closest("[data-case]") || document.createElement("div")) ||
      $(".vt-photo img", dernierLien.closest(".vt-ouverture") || document.createElement("div")) ||
      $("img", dernierLien);
    if (!photo) return;
    photo.style.viewTransitionName = "objet";
    e.viewTransition.finished.finally(() => photo.style.removeProperty("view-transition-name"));
  });

  /* --- Le thème se renverse en cercle depuis le bouton touché --- */
  let enCours = false;
  document.addEventListener(
    "click",
    (e) => {
      const bouton = e.target.closest("[data-bascule-theme]");
      if (!bouton || enCours || calme.matches || !document.startViewTransition) return;
      e.stopImmediatePropagation();
      const r = bouton.getBoundingClientRect();
      const x = r.left + r.width / 2;
      const y = r.top + r.height / 2;
      racine.style.setProperty("--m-x", `${x}px`);
      racine.style.setProperty("--m-y", `${y}px`);
      racine.style.setProperty("--m-r", `${Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y))}px`);
      racine.dataset.passage = "theme";
      const passage = document.startViewTransition(() => {
        enCours = true;
        bouton.click();
        enCours = false;
      });
      passage.finished.finally(() => delete racine.dataset.passage);
    },
    true,
  );

  if (calme.matches) return;

  /* --- L'en-tête s'efface quand on descend, revient dès qu'on remonte --- */
  const entete = $(".hd-section");
  if (entete) {
    let avant = scrollY;
    let trame = 0;
    const libre = () =>
      !racine.hasAttribute("data-verrou") && !$(".hd[data-recherche-ouverte]") && !$("[data-panneau][data-ouvert]") && !entete.contains(document.activeElement);
    addEventListener(
      "scroll",
      () => {
        if (trame) return;
        trame = requestAnimationFrame(() => {
          trame = 0;
          const y = scrollY;
          const ecart = y - avant;
          if (Math.abs(ecart) < 6) return;
          entete.toggleAttribute("data-m-cache", ecart > 0 && y > entete.offsetHeight * 2 && libre());
          avant = y;
        });
      },
      { passive: true },
    );
    entete.addEventListener("focusin", () => entete.removeAttribute("data-m-cache"));
  }

  /* --- L'objet ajouté vole jusqu'au panier --- */
  function photoDe(bouton) {
    const dans = (sel) => bouton.closest(sel);
    if (dans("[data-case]")) return $(".case-art .est-vue img", dans("[data-case]")) || $(".case-art img", dans("[data-case]"));
    if (dans(".vt-ouverture") || dans("[data-barre-vitrine]")) return $(".vt-ouverture .vt-photo img");
    if (dans("[data-barre-achat]") || dans("form") || bouton.matches("[data-ajout-fiche]")) {
      const fiche = $(".gallery-main img");
      if (fiche) return fiche;
    }
    return $("img", dans("li, article") || document.createElement("div"));
  }
  function voler(photo) {
    const cible = $$("[data-ouvre-panier]").find(visible);
    if (!photo || !cible) return;
    const depart = photo.getBoundingClientRect();
    if (!depart.width) return;
    entete?.removeAttribute("data-m-cache");
    // L'en-tête revient peut-être : on vise sa place de repos, pas sa position du moment
    const decalage = entete ? entete.getBoundingClientRect().top - (parseFloat(getComputedStyle(entete).top) || 0) : 0;
    const arrivee = cible.getBoundingClientRect();
    const cote = Math.min(depart.width, depart.height, 168);
    const x0 = depart.left + depart.width / 2 - cote / 2;
    const y0 = depart.top + depart.height / 2 - cote / 2;
    const dx = arrivee.left + arrivee.width / 2 - (x0 + cote / 2);
    const dy = arrivee.top - decalage + arrivee.height / 2 - (y0 + cote / 2);
    const fin = 22 / cote;

    const axeX = document.createElement("div");
    const axeY = document.createElement("div");
    axeX.className = "m-vol";
    axeY.className = "m-vol-y";
    for (const el of [axeX, axeY]) Object.assign(el.style, { width: `${cote}px`, height: `${cote}px` });
    axeX.style.translate = `${x0}px 0`;
    axeY.style.translate = `0 ${y0}px`;
    axeY.style.borderRadius = "18px";
    const copie = new Image();
    copie.alt = "";
    copie.src = photo.currentSrc || photo.src;
    axeY.append(copie);
    axeX.append(axeY);
    document.body.append(axeX);

    // Deux axes, deux courbes : l'horizontale file droit, la verticale monte puis tombe, d'où l'arc
    const duree = 760;
    axeX.animate([{ translate: `${x0}px 0` }, { translate: `${x0 + dx}px 0` }], { duration: duree, easing: "cubic-bezier(0.4, 0, 0.6, 1)", fill: "forwards" });
    // Chaque étape a sa courbe : l'objet jaillit, plafonne, puis tombe de plus en plus vite dans le panier
    axeY.animate(
      [
        { translate: `0 ${y0}px`, scale: 0.6, opacity: 0, borderRadius: "18px", easing: "cubic-bezier(0.2, 0.9, 0.3, 1.2)" },
        { translate: `0 ${y0 - 18}px`, scale: 1, opacity: 1, offset: 0.16, easing: "cubic-bezier(0.3, 0.6, 0.5, 1)" },
        { translate: `0 ${y0 - 60}px`, scale: 0.78, borderRadius: "24px", offset: 0.38, easing: "cubic-bezier(0.55, 0, 0.85, 0.35)" },
        { translate: `0 ${y0 + dy}px`, scale: fin, opacity: 0.9, borderRadius: "50%" },
      ],
      { duration: duree, fill: "forwards" },
    ).finished.then(() => {
      axeX.remove();
      cible.animate([{ scale: 0.82 }, { scale: 1 }], { duration: 620, easing: REBOND });
      // Un petit choc dans la main, seulement après un vrai geste (Android ; l'iPhone l'ignore)
      if (navigator.userActivation?.hasBeenActive) navigator.vibrate?.(12);
    });
  }
  // La barre d'achat de la fiche envoie le formulaire : un seul vol pour un seul geste
  let dernierVol = 0;
  const lancer = (bouton) => {
    if (performance.now() - dernierVol < 400) return;
    dernierVol = performance.now();
    // Plusieurs objets d'un geste : chaque photo part à son tour, un battement après la précédente
    const groupe = bouton.closest("[data-ensemble]");
    if (groupe) {
      $$(".ensemble-art img", groupe).forEach((img, i) => setTimeout(() => voler(img), i * 120));
      return;
    }
    const achetable = bouton.closest(".achetable");
    voler(achetable ? $(".achetable-vignette img", achetable) : photoDe(bouton));
  };
  document.addEventListener(
    "click",
    (e) => {
      const bouton = e.target.closest("[data-ajout], [data-barre-ajout]");
      if (bouton && !bouton.disabled) lancer(bouton);
    },
    true,
  );
  document.addEventListener(
    "submit",
    (e) => {
      const bouton = $("[data-ajout-fiche]", e.target);
      if (bouton && !bouton.disabled) lancer(bouton);
    },
    true,
  );

  /* --- Un favori éclate en petits points de couleur --- */
  document.addEventListener("click", (e) => {
    const fav = e.target.closest("[data-favori]");
    if (!fav) return;
    setTimeout(() => {
      fav.animate([{ scale: 0.7 }, { scale: 1 }], { duration: 700, easing: REBOND });
      if (fav.getAttribute("aria-pressed") !== "true") return;
      const r = fav.getBoundingClientRect();
      for (let i = 0; i < 8; i++) {
        const eclat = document.createElement("span");
        eclat.className = "m-eclat";
        eclat.style.left = `${r.left + r.width / 2}px`;
        eclat.style.top = `${r.top + r.height / 2}px`;
        document.body.append(eclat);
        const angle = (i / 8) * Math.PI * 2 + Math.random() * 0.4;
        const loin = 22 + Math.random() * 12;
        eclat
          .animate(
            [
              { translate: "0 0", scale: 1, opacity: 1 },
              { translate: `${Math.cos(angle) * loin}px ${Math.sin(angle) * loin}px`, scale: 0, opacity: 0.6 },
            ],
            { duration: 520 + Math.random() * 160, easing: SORTIE },
          )
          .finished.then(() => eclat.remove());
      }
    }, 0);
  });

  /* --- Au toucher, les boutons s'enfoncent, puis reviennent sur un ressort --- */
  const PRESSABLE = ".btn, .icon-btn, .fav, .chip, .famille-lien, [data-case]";
  document.addEventListener(
    "pointerdown",
    (e) => {
      const el = e.target.closest(PRESSABLE);
      if (!el || el.disabled || e.button > 0) return;
      // Au doigt sur les photos d'une case, le geste peut être un glissement : la case ne bouge pas sous le ruban
      if (e.pointerType !== "mouse" && e.target.closest("[data-defile]")) return;
      const appui = el.animate([{ scale: 1 }, { scale: el.matches(".famille-lien, [data-case]") ? 0.985 : 0.95 }], { duration: 110, easing: "ease-out", fill: "forwards" });
      const relacher = () => {
        removeEventListener("pointerup", relacher);
        removeEventListener("pointercancel", relacher);
        const depuis = getComputedStyle(el).scale;
        appui.cancel();
        el.animate([{ scale: depuis === "none" ? 1 : depuis }, { scale: 1 }], { duration: 560, easing: SOUPLE });
      };
      addEventListener("pointerup", relacher);
      addEventListener("pointercancel", relacher);
    },
    { passive: true },
  );

  /* --- Les chiffres des vétérinaires roulent comme un compteur : chaque chiffre fait un tour et s'arrête sur sa valeur --- */
  const chiffres = $$(".vt-chiffres .vt-voix, .vt-fait .vt-voix").filter((el) => !el.children.length && /\d/.test(el.textContent));
  if (chiffres.length && "IntersectionObserver" in window) {
    const SERIE = "01234567890123456789".split("").map((d) => `<span>${d}</span>`).join("");
    for (const el of chiffres) {
      const texte = el.textContent;
      let rang = 0;
      // Le texte reste lu tel quel ; seul l'affichage passe en rouleaux
      const visuel = texte.replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" })[c]).replace(/\d/g, (d) => `<span class="m-odo" style="--r:${rang++};--fin:${10 + Number(d)}"><span class="m-odo-place">${d}</span><span class="m-odo-ruban">${SERIE}</span></span>`);
      el.innerHTML = `<span class="sr-only">${el.innerHTML}</span><span aria-hidden="true">${visuel}</span>`;
    }
    const veille = new IntersectionObserver(
      (entrees) => {
        for (const entree of entrees) {
          if (!entree.isIntersecting) continue;
          veille.unobserve(entree.target);
          $$(".m-odo", entree.target).forEach((o) => o.setAttribute("data-tourne", ""));
        }
      },
      { threshold: 0.6 },
    );
    for (const el of chiffres) veille.observe(el);
  }

  /* --- Les puces d'un guide éclosent l'une après l'autre quand leur liste arrive à l'écran --- */
  const listes = $$(".article-corps > ul");
  if (listes.length && !calme.matches && "IntersectionObserver" in window) {
    const guetteur = new IntersectionObserver(
      (entrees) => {
        for (const entree of entrees) {
          if (!entree.isIntersecting) continue;
          guetteur.unobserve(entree.target);
          entree.target.setAttribute("data-m-vu", "");
        }
      },
      { threshold: 0.35 },
    );
    for (const ul of listes) {
      $$(":scope > li", ul).forEach((li, i) => li.style.setProperty("--i", i));
      ul.setAttribute("data-m-puces", "");
      guetteur.observe(ul);
    }
  }

  /* --- La sélection se recompose : au filtre ou au tri, chaque case glisse vers sa nouvelle place --- */
  window.animolifeRecomposer = (maj, plateau) => {
    const cases = plateau ? $$("[data-case]", plateau) : [];
    const r = plateau?.getBoundingClientRect();
    // Hors de l'écran ou trop de cases : le filtre s'applique d'un coup, sans rien coûter
    if (!document.startViewTransition || !r || r.top > innerHeight || r.bottom < 0 || cases.length > 60) return maj();
    for (const c of cases) c.style.viewTransitionName = `case-${c.dataset.id}`;
    racine.dataset.passage = "tri";
    document.startViewTransition(maj).finished.finally(() => {
      delete racine.dataset.passage;
      for (const c of cases) c.style.removeProperty("view-transition-name");
    });
  };

  /* --- Les photos qui arrivent en cours de route se fondent au lieu d'apparaître d'un coup --- */
  const fondre = (img) => {
    if (img.complete || img.dataset.mAttente !== undefined) return;
    img.dataset.mAttente = "";
    const montrer = () => {
      delete img.dataset.mAttente;
      img.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 520, easing: "ease-out" });
    };
    img.addEventListener("load", montrer, { once: true });
    img.addEventListener("error", montrer, { once: true });
  };
  $$(".case-art img, .famille-art img, .line-art img").forEach(fondre);

  /* --- Le panier : à chaque ouverture, ses lignes entrent l'une après l'autre --- */
  const panier = $("#panier");
  if (panier) {
    new MutationObserver(() => {
      if (panier.dataset.open !== "true" || panier.hasAttribute("data-m-entree")) return;
      panier.setAttribute("data-m-entree", "");
      setTimeout(() => panier.removeAttribute("data-m-entree"), 800);
    }).observe(panier, { attributes: true, attributeFilter: ["data-open"] });
  }
})();
